import moment from 'moment';
import { Voyage } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class VoyageParser {
    static toGateway(voyage, app) {
        return {
            Id: voyage._id,
            CreatedTimestamp: moment(voyage.createdTimestamp).utc().toISOString(),
            Author: getAuthorRefForGateway(voyage.author, app),
            VoyageNumber: voyage.voyageNumber,
            PortFrom: voyage.portFrom,
            PortTo: voyage.portTo,
            StartTime: moment(voyage.startTime).utc().toISOString(),
            EndTime: voyage.endTime ? moment(voyage.endTime).utc().toISOString() : undefined,
            ETA: voyage.estimatedTimeOfArrival ? moment(voyage.estimatedTimeOfArrival).utc().toISOString() : undefined,
            Predecessor: voyage.predecessor,
        };
    }
    static fromGateway(gatewayVoyage, app) {
        const voyage = new Voyage({ author: getAuthorRefFromGateway(gatewayVoyage.Author, app) });
        voyage.voyageNumber = gatewayVoyage.VoyageNumber;
        voyage.portFrom = gatewayVoyage.PortFrom;
        voyage.portTo = gatewayVoyage.PortTo;
        voyage.startTime = gatewayVoyage.StartTime;
        if (gatewayVoyage.EndTime) {
            voyage.endTime = gatewayVoyage.EndTime;
        }
        if (gatewayVoyage.ETA) {
            voyage.estimatedTimeOfArrival = gatewayVoyage.ETA;
        }
        if (gatewayVoyage.Predecessor) {
            voyage.predecessor = Voyage.createRef(gatewayVoyage.Predecessor._id);
        }
        Object.assign(voyage, {
            _id: gatewayVoyage.Id,
            createdTimestamp: gatewayVoyage.CreatedTimestamp,
        });
        return voyage;
    }
}
//# sourceMappingURL=VoyageParser.js.map